import { styled } from '@mui/material';
import { grey } from '@mui/material/colors';

export const StyledFieldSet = styled('fieldset')(() => ({
  padding: 0,
  margin: 0,
  border: 0,
}));

export const ResourceP = styled('p')(() => ({
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  color: `${grey[700]}`,
}));
